export enum AUTH_STATE {
  UNAUTHENTICATED,
  AUTHENTICATED,
  LOADING,
}

export enum ROUTE_ALIASES {
  AUTH_CALLBACK_PAGE = '/callback',
  LOGIN = '/login',
  HOME = '/',
  NOT_FOUND = '*',
  ORGANIZATIONS = '/organizations',
  ORGANIZATION_DETAIL = '/organizations/:id/:tab?',
  SHORT_CODES = '/short-codes',
  STATISTICS = '/statistics',
  BACKGROUNDS = '/backgrounds',
  SUPER_ADMINS = '/super-admins',
  CHURCH_ADMINS = '/church-admins',
  SUGGESTED_MODULES = '/suggested-modules',
  MESSAGE_TEMPLATES = '/message-templates',
  FORM_TEMPLATES = '/form-templates',
  REPORTS = '/reports',
}

export enum CUSTOM_ICONS {
  CHURCH_SOLID = 'ChurchSolidSvg',
  COMMENTS_DOT = 'CommentsDotSvg',
  CHART_SIMPLE = 'ChartSimpleSvg',
  DIOCESE_BUILDING_SOLID = 'DioceseBuildingSolidSvg',
  ADORATION = 'AdorationSvg',
  CAMINO = 'CaminoSvg',
  MY_PARISH = 'MyParishSvg',
  FACILITIES = 'FacilitiesSvg',
  MASS_INTENTIONS = 'MassIntentionsSvg',
  MINISTRIES = 'MinistriesSvg',
  FORMS = 'FormsSvg',
  MESSAGES = 'MessagesSvg',
}

export enum API_QUERY_PARAMS {
  TERM = 'term',
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  CURSOR = 'cursor',
  LIMIT = 'limit',
  PAGE = 'page',
  SORT_BY = 'sortBy',
  SORT_ORDER = 'sortOrder',
  STATUS = 'status',
  PROGRAMS = 'programs[]',
  DIOCESE = 'diocese',
  CLUSTER = 'cluster',
}

export enum SORT_ORDER {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum SORT_BY {
  NAME = 'name',
  DIOCESE = 'diocese',
}

export enum DAYS_OF_WEEK {
  SUNDAY = 'sunday',
  MONDAY = 'monday',
  TUESDAY = 'tuesday',
  WEDNESDAY = 'wednesday',
  THURSDAY = 'thursday',
  FRIDAY = 'friday',
  SATURDAY = 'saturday',
}

export const DAYS_OF_WEEK_LABELS = {
  [DAYS_OF_WEEK.SUNDAY]: 'Sunday',
  [DAYS_OF_WEEK.MONDAY]: 'Monday',
  [DAYS_OF_WEEK.TUESDAY]: 'Tuesday',
  [DAYS_OF_WEEK.WEDNESDAY]: 'Wednesday',
  [DAYS_OF_WEEK.THURSDAY]: 'Thursday',
  [DAYS_OF_WEEK.FRIDAY]: 'Friday',
  [DAYS_OF_WEEK.SATURDAY]: 'Saturday',
};

export enum BILLING_METHOD {
  CREDIT_CARD = 'credit_card',
  INVOICE = 'invoice',
  NOT_BILLED = 'not_billed',
}

export const BILLING_METHOD_LABELS = {
  [BILLING_METHOD.CREDIT_CARD]: 'Credit Card',
  [BILLING_METHOD.INVOICE]: 'Invoice',
  [BILLING_METHOD.NOT_BILLED]: 'Not Billed',
};

export enum BULLETIN_TYPE {
  NONE = 'none',
  DIOCESAN = 'diocesan',
  LPI = 'lpi',
  OTHER = 'other',
}
